import { Pagination, PaginationItem, PaginationRenderItemParams, useTheme } from '@mui/material';

import { Maybe } from '@/types';
import TAGSvgIcon from '@/components/TAGSvgIcon';

import { getPaginationStyles } from '../BlogListPageDefault/BlogListPageDefault.styles';

export interface IPaginationProps {
	totalBlogs: number;
	countPerPage?: Maybe<number>;
	handlePaginationChangeEvent: (e: React.ChangeEvent<unknown>, page: number) => void;
	currentPage?: number;
}

const PaginationNextItem = () => {
	return (
		<>
			Next <TAGSvgIcon icon="ChevronRightFunc" size={32} sx={{ display: 'inline-block' }} />
		</>
	);
};

const PaginationPrevioustItem = () => {
	return (
		<>
			<TAGSvgIcon icon="ChevronLeftFunc" size={32} sx={{ display: 'inline-block' }} />
			Previous
		</>
	);
};

const PaginationRenderItem = (params: PaginationRenderItemParams) => {
	const itemComponents = {
		next: PaginationNextItem,
		previous: PaginationPrevioustItem,
	};
	return <PaginationItem slots={itemComponents} {...params} />;
};

export const getPaginationCount = (totalCount: number, countPerPage?: Maybe<number>) => {
	return Math.ceil(totalCount / (countPerPage ?? 12));
};

export default function BlogListPagination({
	totalBlogs,
	countPerPage,
	handlePaginationChangeEvent,
	currentPage,
}: Readonly<IPaginationProps>) {
	const theme = useTheme();
	const count = getPaginationCount(totalBlogs, countPerPage);

	return (
		<Pagination
			count={count}
			shape="rounded"
			size="large"
			sx={getPaginationStyles(theme)}
			renderItem={PaginationRenderItem}
			onChange={handlePaginationChangeEvent}
			page={currentPage}
		/>
	);
}
